var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M77,0A12,12,0,0,0,89-12,12,12,0,0,0,77-24,12,12,0,0,0,65-12,12,12,0,0,0,77,0Z",
    fill: "none",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(-600 -313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(535 337)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M60-29H94V5H60Z",
    fill: "#d7d7d7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(608 315)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "?",
    transform: "translate(0 17)",
    fill: "#2b2b2b",
    fontSize: 18,
    fontFamily: "ClanPro-NarrBlack, Clan Pro",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "?"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.668837a8.svg";
export { ForwardRef as ReactComponent };